let delayTimer;
const delayCall = (callback, time = 200) => {
  clearTimeout(delayTimer);
  delayTimer = setTimeout(() => {
    callback();
  }, 200);
};

export default delayCall;
